/**
 * @generated SignedSource<<f2886be5685e239d3c2a48b576bb2208>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphDeal_AtlassianSearchPage$data = {
  readonly entity: {
    readonly dealClosedAt?: string | null | undefined;
    readonly lastActivity?: {
      readonly event: string | null | undefined;
      readonly lastActivityAt: string | null | undefined;
    } | null | undefined;
    readonly owners?: ReadonlyArray<{
      readonly thirdPartyUser: {
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly parent?: {
      readonly displayName?: string | null | undefined;
      readonly id?: string;
    } | null | undefined;
    readonly stage?: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null | undefined;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null | undefined;
    readonly lastModifiedDate: string | null | undefined;
    readonly providerId: string | null | undefined;
    readonly subtype: string | null | undefined;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphDeal_AtlassianSearchPage";
};
export type searchGraphDeal_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphDeal_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphDeal_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__isdealownersenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "searchGraphDeal_AtlassianSearchPage",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "stage"
            },
            {
              "kind": "ScalarField",
              "name": "dealClosedAt"
            },
            {
              "concreteType": "ExternalDealLastActivity",
              "kind": "LinkedField",
              "name": "lastActivity",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "lastActivityAt"
                },
                {
                  "kind": "ScalarField",
                  "name": "event"
                }
              ]
            },
            {
              "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "ExternalUser",
                  "kind": "LinkedField",
                  "name": "owners",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "ThirdPartyUser",
                      "kind": "LinkedField",
                      "name": "thirdPartyUser",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "name"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "kind": "LinkedField",
              "name": "parent",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "displayName"
                    }
                  ],
                  "type": "ExternalCustomerOrg"
                }
              ]
            }
          ],
          "type": "ExternalDeal"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "a67dcd516788ae186b2f421b3cb9f8c0";

export default node;
